<app-bottom-sheet #sheet ariaLabel="بیشتر">
	<ng-template #body>
		<div class="flex flex-col divide-y divide-stroke-100 pb-1" data-cy="symbol-detail-more-content">
			<a
				class="flex h-9 w-full items-center gap-2 text-3.25 font-medium text-gray-900"
				data-cy="symbol-detail-more-easy-chart"
				[href]="easyChartUrl()"
				(click)="onEasyChartClick($event)">
				<ui-icon width="18" height="18" class="shrink-0" iconName="easychart" aria-hidden="true" />
				<span class="min-w-0 flex-1 truncate text-right">ایزی چارت</span>
				<ui-icon width="20" height="20" class="shrink-0" iconName="chevron-left" aria-hidden="true" />
			</a>
			@if (imeDetailPageUrl(); as url) {
				<a
					class="flex h-9 w-full items-center gap-2 text-3.25 font-medium text-gray-900"
					target="_blank"
					rel="noopener noreferrer"
					data-cy="symbol-detail-more-specifications"
					[href]="url"
					(click)="close()">
					<ui-icon width="18" height="18" class="shrink-0" iconName="info-box" aria-hidden="true" />
					<span class="min-w-0 flex-1 truncate text-right">مشخصات گواهی سپرده</span>
					<ui-icon width="20" height="20" class="shrink-0" iconName="chevron-left" aria-hidden="true" />
				</a>
			}
			<a
				class="flex h-9 w-full items-center gap-2 text-3.25 font-medium text-gray-900"
				target="_blank"
				rel="noopener noreferrer"
				data-cy="symbol-detail-more-warehouse-notice"
				[href]="imeWarehouseUrl"
				(click)="close()">
				<ui-icon width="18" height="18" iconName="salaf-contracts" aria-hidden="true" viewBox="0 0 20 20" />
				<span class="min-w-0 flex-1 truncate text-right">اطلاعیه گشایش انبار</span>
				<ui-icon width="20" height="20" class="shrink-0" iconName="chevron-left" aria-hidden="true" />
			</a>
		</div>
	</ng-template>
</app-bottom-sheet>
